import { DatasourceTypeEnum } from '@y42/json-schema';

const BackendDatasourceTypeMap: { [key in DatasourceTypeEnum]?: DatasourceTypeEnum } = {
  [DatasourceTypeEnum.Xlsx]: DatasourceTypeEnum.FileUpload,
  [DatasourceTypeEnum.Csv]: DatasourceTypeEnum.FileUpload,

  [DatasourceTypeEnum.MysqlOnRds]: DatasourceTypeEnum.Mysql,
  [DatasourceTypeEnum.MysqlOnGoogleCloudSql]: DatasourceTypeEnum.Mysql,
  [DatasourceTypeEnum.AmazonAuroraMysql]: DatasourceTypeEnum.Mysql,
  [DatasourceTypeEnum.LoadedCommerceViaMysql]: DatasourceTypeEnum.Mysql,
  [DatasourceTypeEnum.MagentoViaMysqlAmazonRds]: DatasourceTypeEnum.Mysql,
  [DatasourceTypeEnum.WoocommerceViaMysql]: DatasourceTypeEnum.Mysql,
  [DatasourceTypeEnum.SpreeCommerceViaMysql]: DatasourceTypeEnum.Mysql,
  [DatasourceTypeEnum.PrestashopViaMysql]: DatasourceTypeEnum.Mysql,
  [DatasourceTypeEnum.OscommerceViaMysql]: DatasourceTypeEnum.Mysql,
  [DatasourceTypeEnum.Mariadb]: DatasourceTypeEnum.Mysql,
  [DatasourceTypeEnum.MariadbOnAmazonRds]: DatasourceTypeEnum.Mysql,
  [DatasourceTypeEnum.MariadbOnAzureDatabase]: DatasourceTypeEnum.Mysql,

  [DatasourceTypeEnum.SqlServer]: DatasourceTypeEnum.Mssql,
  [DatasourceTypeEnum.SqlServerOnRds]: DatasourceTypeEnum.Mssql,

  [DatasourceTypeEnum.OracleOnAmazonRds]: DatasourceTypeEnum.Oracle,
};

// Some datasources exist only on the frontend, that's why before sending the request to the backend
// they should be mapped to a proper backend-compatible type
export const BackendDatasourceTypeMapper = (type: DatasourceTypeEnum): DatasourceTypeEnum => {
  return BackendDatasourceTypeMap[type] ?? type;
};
